import { Segment } from 'semantic-ui-react';
import styled from 'styled-components';

const StyledCard = styled(Segment)<{ selected: boolean }>`
  transition: all 0.2s ease;
  cursor: pointer;
  box-shadow: ${({ selected }) => (selected ? '0 0 0 2px var(--primary, #2185d0)' : 'none')};
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const CardContentWrapper = styled.div`
  padding: 1rem;
`;

const Label = styled.label`
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
`;

const Value = styled.div<{ color?: string }>`
  font-size: 1.125rem !important;
  font-weight: 600;
  color: ${({ color }) => color || '#000'};
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  .date {
   font-size: 16px !important;
   font-weight: bold;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

export const MilkTestEl = {
  StyledCard,
  ButtonRow,
  Column,
  Grid,
  Row,
  Value,
  Label,
  CardContentWrapper
}